import { render, staticRenderFns } from "./UserPrivacySetting.vue?vue&type=template&id=72f50266"
import script from "./UserPrivacySetting.vue?vue&type=script&lang=js"
export * from "./UserPrivacySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports